import { Injectable } from '@angular/core';
import { PoI18nService } from '@po-ui/ng-components';
import { Observable } from 'rxjs';
import { LiteralsWords } from './../../i18n/literals.model';

@Injectable({
  providedIn: 'root'
})
export class LiteralsService {
  literals: LiteralsWords;
  language: string;
  languageList = {
    pt: 'pt-BR',
    en: 'en-US',
    es: 'es-ES',
    ru: 'ru-RU'
  };

  constructor(private i18nService: PoI18nService) {
    const fixLanguage = navigator.language.slice(0, 2).toLowerCase();
    this.getLiterals(fixLanguage).subscribe(
      (literalsRecive: LiteralsWords) => (this.literals = literalsRecive)
    );
  }

  getLiterals(language: string): Observable<object> {
    this.language = this.languegeToString(language);
    this.i18nService.setLanguage(language.slice(0, 2));
    return this.i18nService.getLiterals({ language: this.language });
  }

  getLiteralModule(): LiteralsWords {
    return this.literals;
  }

  languegeToString(language: string): string {
    return this.languageList[language];
  }
}
